<template lang="pug">
  .fill-in-quotation--shortcut
    el-col(:span="20")
      div(v-if="quotationDetail.length === 0 && viewMode") —
      el-button(
        v-else
        @click="onClick"
      ) {{ buttonStr }}

    el-col(:span="20")
      QuotationOverview(
        :data="quotationOverviewArr"
        style="width: 600px; margin-top: 20px"
      )

    quotation-dialog(
      v-if="quotationDetail.length > 0 && quotationDetailVisible"
      :visible="quotationDetailVisible"
      :data="quotationDetail"
      :viewMode="viewMode"
      :hasFilled="hasFilled"
      @close="handleDialogClose"
    )
</template>

<script>
import QuotationDialog, { normalizeQuotation } from '@/components/QuotationDialog'
import QuotationOverview from '@/components/QuotationOverview'

export default {
  props: {
    viewMode: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: null
    }
  },
  components: {
    QuotationDialog,
    QuotationOverview
  },
  data () {
    return {
      quotationDetailVisible: false,
      quotationDetail: [],
      quotationOverviewArr: [],
      hasFilled: false,
      tempSavedData: null
    }
  },
  computed: {
    buttonStr () {
      if (this.viewMode) return this.$t('查看报价明细')
      if (this.hasFilled) return this.$t('修改报价明细')
      return this.$t('填写报价明细')
    }
  },
  watch: {
    data () {
      this.quotationDetail = this.data.vendor_price.map(category => normalizeQuotation(category))
      this.quotationOverviewArr = this.data.price_overview
      this.hasFilled = this.data.summary.vendor_price.length !== 0
    }
  },
  methods: {
    onClick () {
      this.quotationDetailVisible = true
    },
    handleDialogClose (res, params) {
      this.quotationDetailVisible = false
      if (res) {
        this.quotationDetail = res.vendor_price.map(category => normalizeQuotation(category))
        this.tempSavedData = res.vendor_price.map(category => normalizeQuotation(category))
        this.quotationOverviewArr = res.price_overview
        this.hasFilled = res.vendor_price.length !== 0
        this.$emit('close', params)
      } else {
        if (this.tempSavedData != null) {
          this.quotationDetail = this.tempSavedData
        } else {
          this.quotationDetail = this.data.vendor_price.map(category => normalizeQuotation(category))
        }
      }
    }
  }
}
</script>

<style lang="stylus">
.fill-in-quotation--shortcut .campaign-tab__item
  width 140px
  font-size $font-small
</style>
